/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateProductPageComponentMutationRequest,
  CreateProductPageComponentMutationResponse,
} from "../types/CreateProductPageComponent.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createProductPageComponentMutationKey = () =>
  [{ url: "/v1/organization-settings/product-page-components" }] as const

export type CreateProductPageComponentMutationKey = ReturnType<
  typeof createProductPageComponentMutationKey
>

/**
 * @summary Create product page component
 * {@link /v1/organization-settings/product-page-components}
 */
export async function createProductPageComponent(
  data: CreateProductPageComponentMutationRequest,
  config: Partial<RequestConfig<CreateProductPageComponentMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateProductPageComponentMutationResponse,
    ResponseErrorConfig<Error>,
    CreateProductPageComponentMutationRequest
  >({
    method: "POST",
    url: `/v1/organization-settings/product-page-components`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createProductPageComponentMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateProductPageComponentMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createProductPageComponentMutationKey()
  return mutationOptions<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createProductPageComponent(data, config)
    },
  })
}

/**
 * @summary Create product page component
 * {@link /v1/organization-settings/product-page-components}
 */
export function useCreateProductPageComponent<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateProductPageComponentMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateProductPageComponentMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<CreateProductPageComponentMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createProductPageComponentMutationKey()

  const baseOptions = createProductPageComponentMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    TContext
  >
}
